import { render, staticRenderFns } from "./CertificateAddressDistanceField.vue?vue&type=template&id=5c3963ce&scoped=true"
import script from "./CertificateAddressDistanceField.vue?vue&type=script&lang=ts"
export * from "./CertificateAddressDistanceField.vue?vue&type=script&lang=ts"
import style0 from "./CertificateAddressDistanceField.vue?vue&type=style&index=0&id=5c3963ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3963ce",
  null
  
)

export default component.exports